import { render } from "./pos-notification.vue?vue&type=template&id=2573d7b1"
import script from "./pos-notification.vue?vue&type=script&lang=js"
export * from "./pos-notification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__